import React, { useState } from 'react';
import { Alert, Box, Button, Paper } from '@mui/material';
import BriefsLandingPage from './BriefsLandingPage';
import BriefWizardPage from './BriefWizardPage';
import { IUser } from '../../types/damTypes';
import { hasPermission } from '../../utils/permissionUtils';

interface BriefsModuleProps {
  onClose: () => void;
  currentUser: IUser | null;
}

type View = 
  | { type: 'landing' }
  | { type: 'wizard'; briefId?: string };

const BriefsModule: React.FC<BriefsModuleProps> = ({ onClose, currentUser }) => {
  const [view, setView] = useState<View>({ type: 'landing' });
  const canAccessBriefs = hasPermission(currentUser, 'briefs:read');

  if (!canAccessBriefs) {
    return (
      <Box sx={{ height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', bgcolor: '#f5f5f5', p: 3 }}>
        <Paper sx={{ maxWidth: 560, width: '100%', p: 3 }}>
          <Alert severity="warning" sx={{ mb: 2 }}>
            Du har inte behörighet att visa Briefs/beställningar. Rollen behöver ha <strong>`briefs:read`</strong>.
          </Alert>
          <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
            <Button variant="contained" onClick={onClose} sx={{ bgcolor: '#1B3967', '&:hover': { bgcolor: '#0f2341' } }}>
              Stäng
            </Button>
          </Box>
        </Paper>
      </Box>
    );
  }

  const handleCreateNew = () => {
    setView({ type: 'wizard' });
  };

  const handleEditBrief = (briefId: string) => {
    setView({ type: 'wizard', briefId });
  };

  const handleBackToLanding = () => {
    setView({ type: 'landing' });
  };

  if (view.type === 'wizard') {
    return (
      <BriefWizardPage
        briefId={view.briefId}
        onClose={handleBackToLanding}
        onSaved={handleBackToLanding}
      />
    );
  }

  return (
    <BriefsLandingPage
      onClose={onClose}
      onCreateNew={handleCreateNew}
      onEditBrief={handleEditBrief}
    />
  );
};

export default BriefsModule;
